"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var environment_1 = __importDefault(require("../core/environment"));
var network_1 = __importDefault(require("./network"));
var transports_1 = __importDefault(require("./transports"));
function aWebEnvironment(opts) {
    var network = new network_1.default();
    var transportsManager = (0, transports_1.default)({
        baseUrl: opts.url,
        instanceUpdater: opts.instanceUpdater,
        siteRevision: opts.siteRevision,
    }, opts.useHttpStreaming);
    return new environment_1.default({ transportsManager: transportsManager, network: network });
}
exports.default = aWebEnvironment;
//# sourceMappingURL=environment.js.map